import { Emitter } from "../util/Emitter.mjs";
export class Relays extends Emitter {
    constructor(connections) {
        super();
        this.connections = connections;
        this.send = (...payload) => {
            this.connections.forEach(connection => {
                connection.send(payload);
            });
        };
        this.onMessage = (connection, [verb, ...payload]) => {
            this.emit(verb, connection.url, ...payload);
        };
        this.cleanup = () => {
            this.removeAllListeners();
            this.connections.forEach(connection => {
                connection.off('receive', this.onMessage);
            });
        };
        connections.forEach(connection => {
            connection.on('receive', this.onMessage);
        });
    }
}
//# sourceMappingURL=Relays.mjs.map